import { ServiceWorkerMessageType } from "@axa-fr/oidc-client";

const TIMEOUT_MS = 6 * 60 * 1000;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// The old worker can take up to 5 minutes to hand over (AXA keeps a keep-alive
// request open), so wait for the new one before starting OIDC
export const waitForOidcWorker = async (registerWorker, scriptUrl) => {
  const serviceWorker = navigator.serviceWorker;
  if (!serviceWorker) return;

  let registration;
  try {
    registration = await registerWorker();
  } catch (error) {
    // Let react-oidc handle it
    console.warn("[oidc-worker] Registration failed", error);
    return;
  }

  const deadline = Date.now() + TIMEOUT_MS;
  let claimSent = false;
  while (serviceWorker.controller?.scriptURL !== scriptUrl) {
    if (Date.now() > deadline) {
      throw new Error("The authentication worker update timed out.");
    }

    const { installing, waiting, active } = registration;
    if (waiting) {
      waiting.postMessage({ type: ServiceWorkerMessageType.SKIP_WAITING });
    } else if (!installing && active?.scriptURL !== scriptUrl) {
      // Another tab registered an older version
      registration = await registerWorker();
    } else if (!installing && active.state === "activated" && !claimSent) {
      // First visit
      claimSent = true;
      active.postMessage({ type: ServiceWorkerMessageType.CLAIM }, [
        new MessageChannel().port2,
      ]);
    }
    await sleep(1000);
  }
};
